export const tailwindLightTokens = {
  brand: {
    primary: '#3b82f6',
  },

  // Backgrounds
  background: {
    base: '#F4F4F5', // --tui-background-base
    'base-alt': '#F6F6F6', // --tui-background-base-alt
    neutral: {
      '1': 'rgba(0, 0, 0, .02)', // --tui-background-neutral-1
      '1-hover': 'rgba(0, 0, 0, .08)', // --tui-background-neutral-1-hover
      '1-pressed': 'rgba(0, 0, 0, .12)', // --tui-background-neutral-1-pressed
      '2': 'rgba(0, 0, 0, .08)', // --tui-background-neutral-2
      '2-hover': 'rgba(0, 0, 0, .1)', // --tui-background-neutral-2-hover
      '2-pressed': 'rgba(0, 0, 0, .14)', // --tui-background-neutral-2-pressed
      '3': '#ffffff', // --tui-background-neutral-4 (plain white, no opacity)
      '3-hover': '#ededed', // --tui-background-neutral-4-hover (solid color)
      '3-pressed': '#cccccc', // --tui-background-neutral-4-pressed (solid color)
    },
    accent: {
      '1': 'rgb(var(--colors-brand-primary))', // --tui-background-accent-1
      '1-hover': `color-mix(
    in srgb,
        rgb(var(--colors-brand-primary)),
        white 18%
      )`, // accent-1-hover
      '1-pressed': `color-mix(
    in srgb,
        rgb(var(--colors-brand-primary)),
        black 18%
      )`, // accent-1-pressed
      '2': '#ff7043', // --tui-background-accent-2
      '2-hover': '#ff9a94', // --tui-background-accent-2-hover
      '2-pressed': '#e7716a', // --tui-background-accent-2-pressed
      opposite: '#000', // --tui-background-accent-opposite
      'opposite-hover': '#333', // --tui-background-accent-opposite-hover
      'opposite-pressed': '#808080', // --tui-background-accent-opposite-pressed
    },
    elevation: {
      '1': '#F8F8F9', // --tui-background-elevation-1
      '2': '#FCFCFC', // --tui-background-elevation-2
      '3': '#FFFFFF', // --tui-background-elevation-3
    },
  },

  // Service
  service: {
    'autofill-background': '#fff5c0', // --tui-service-autofill-background
    'selection-background': 'rgba(112, 182, 246, .12)', // --tui-service-selection-background
    backdrop: 'rgba(0, 0, 0, .75)', // --tui-service-backdrop
  },

  // Borders
  border: {
    abnormal: '#D4D4D8',
    normal: 'rgba(0, 0, 0, .1)', // --tui-border-normal
    hover: 'rgba(0, 0, 0, .16)', // --tui-border-hover
    focus: 'rgba(51, 51, 51, .64)', // --tui-border-focus
  },

  // Status
  status: {
    negative: '#f45725', // --tui-status-negative
    'negative-pale': 'rgba(244, 87, 37, .12)', // --tui-status-negative-pale
    'negative-pale-hover': 'rgba(244, 87, 37, .24)', // --tui-status-negative-pale-hover
    positive: '#4ac99b', // --tui-status-positive
    'positive-pale': 'rgba(74, 201, 155, .12)', // --tui-status-positive-pale
    'positive-pale-hover': 'rgba(74, 201, 155, .24)', // --tui-status-positive-pale-hover
    warning: '#ffc700', // --tui-status-warning
    'warning-pale': 'rgba(255, 199, 0, .12)', // --tui-status-warning-pale
    'warning-pale-hover': 'rgba(255, 199, 0, .24)', // --tui-status-warning-pale-hover
    info: '#70b6f6', // --tui-status-info
    'info-pale': 'rgba(112, 182, 246, .12)', // --tui-status-info-pale
    'info-pale-hover': 'rgba(112, 182, 246, .24)', // --tui-status-info-pale-hover
    neutral: '#79818c', // --tui-status-neutral
  },

  // Text
  text: {
    primary: '#262626', // --tui-text-primary
    secondary: 'rgba(27, 31, 59, .65)', // --tui-text-secondary
    tertiary: 'rgba(27, 31, 59, .4)', // --tui-text-tertiary
    'primary-on-accent-1': '#fff', // --tui-text-primary-on-accent-1
    'primary-on-accent-2': '#fff', // --tui-text-primary-on-accent-2
    action: `color-mix(
      in srgb,
          rgb(var(--colors-brand-primary)) 70%,
          white 30%
        )`,

    'action-hover': `color-mix(
          in srgb,
              rgb(var(--colors-brand-primary)) 70%,
              black 30%
            )`,
    positive: '#3aa981', // --tui-text-positive
    'positive-hover': '#7ac5aa', // --tui-text-positive-hover
    negative: '#dd4c1e', // --tui-text-negative
    'negative-hover': '#e38163', // --tui-text-negative-hover
  },

  // Charts - categorical colors for charts
  chart: {
    categorical: {
      '00': '#526ed3', // --tui-chart-categorical-00 (uses --tui-background-accent-1)
      '01': '#ea97c4', // --tui-chart-categorical-01
      '02': '#a0c5df', // --tui-chart-categorical-02
      '03': '#fee797', // --tui-chart-categorical-03
      '04': '#b0b0b0', // --tui-chart-categorical-04
      '05': '#e29398', // --tui-chart-categorical-05
      '06': '#b8474e', // --tui-chart-categorical-06
      '07': '#fcc068', // --tui-chart-categorical-07
      '08': '#ff8a00', // --tui-chart-categorical-08
      '09': '#dab3f9', // --tui-chart-categorical-09
      '10': '#7b439e', // --tui-chart-categorical-10
      '11': '#8dda71', // --tui-chart-categorical-11
      '12': '#fcbb14', // --tui-chart-categorical-12
      '13': '#a8cef1', // --tui-chart-categorical-13
      '14': '#bd65a4', // --tui-chart-categorical-14
      '15': '#7fd7cc', // --tui-chart-categorical-15
      '16': '#2fad96', // --tui-chart-categorical-16
      '17': '#d4aca2', // --tui-chart-categorical-17
      '18': '#9d6f64', // --tui-chart-categorical-18
      '19': '#d2e9a2', // --tui-chart-categorical-19
      '20': '#aadc42', // --tui-chart-categorical-20
      '21': '#3682db', // --tui-chart-categorical-21
      '22': '#34b41f', // --tui-chart-categorical-22
    },
  },

  // Shadows
  shadow: {
    small: '0 .25rem 1.25rem rgba(0, 0, 0, .1)', // --tui-shadow-small
    'small-hover': '0 1rem 2.5rem rgba(0, 0, 0, .14)', // --tui-shadow-small-hover
    medium: '0 .375rem 2rem rgba(0, 0, 0, .12)', // --tui-shadow-medium
    'medium-hover': '0 1.25rem 4rem rgba(0, 0, 0, .18)', // --tui-shadow-medium-hover
    popup: '0 1.25rem 3rem rgba(0, 0, 0, .2)', // --tui-shadow-popup
  },

  // Disable
  disable: {
    2: '#9AA1AD',
  },
};
